import { isObjectType } from 'remeda'

export type GridSelectionStateApi = {
  readonly getGridOption: (key: 'rowModelType') => unknown
  readonly getSelectedRows: () => readonly unknown[]
  readonly getServerSideSelectionState: () => unknown
}

export type GridExportMenuMode = 'disabled' | 'range' | 'default'

type ServerSideSelectionStateLike = {
  readonly selectAll?: unknown
  readonly selectAllChildren?: unknown
  readonly toggledNodes?: unknown
}

const hasToggledNodes = (state: ServerSideSelectionStateLike): boolean =>
  Array.isArray(state.toggledNodes) && state.toggledNodes.length > 0

export const isServerSideRowSelectionActive = (state: unknown): boolean => {
  if (!isObjectType(state)) {
    return false
  }

  const selectionState = state as ServerSideSelectionStateLike

  return (
    selectionState.selectAll === true ||
    selectionState.selectAllChildren === true ||
    hasToggledNodes(selectionState)
  )
}

export const hasSelectedRowsForExport = (
  api: GridSelectionStateApi
): boolean => {
  if (api.getGridOption('rowModelType') !== 'serverSide') {
    return api.getSelectedRows().length > 0
  }

  try {
    return isServerSideRowSelectionActive(api.getServerSideSelectionState())
  } catch (_error: unknown) {
    return false
  }
}

export const getGridExportMenuMode = ({
  hasSelectedRows,
  hasCellRangeSelection
}: {
  readonly hasSelectedRows: boolean
  readonly hasCellRangeSelection: boolean
}): GridExportMenuMode => {
  if (hasSelectedRows) {
    return 'disabled'
  }

  return hasCellRangeSelection ? 'range' : 'default'
}
